import styled from "styled-components";

const Span = styled.span`
  display: inline-block;
  padding: 0 10px;
`;
export default Span;
